export { NarrowView } from './NarrowView';
